<template>
  <v-card class="mt-2" :elevation="$root.ele">
    <v-card-text class="pa-4 pb-0">
      <v-row>
        <v-col cols="12" sm="4">
          <DateRange
            :clearable="true"
            v-model="form.updated_at"
            label="Date Range (Updated On)"
          />
        </v-col>
        <v-col cols="12" sm="4">
          <v-select
            item-text="name"
            item-value="id"
            :items="templates"
            outlined
            v-model="form.template"
            dense
            hide-details
            label="Templates"
          >
          </v-select>
        </v-col>
        <v-col cols="12" sm="4">
          <v-select
            outlined
            item-text="name"
            item-value="value"
            v-model="form.sms"
            :items="sms"
            dense
            hide-details
            label="SMS Status"
          >
          </v-select>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions class="pb-4 pt-0">
      <v-spacer />
      <v-btn color="grey" @click="reset()" outlined tile depressed width="100"
        >Reset</v-btn
      >
      <v-btn text class="primary mr-2" tile width="100" @click="fetch()">
        Apply</v-btn
      >
    </v-card-actions>
  </v-card>
</template>
<script>
import DateRange from "../DateRange";
import smsList from "../../assets/js/sms_status";
import { status } from "../../assets/js/default.js";
import moment from "moment";
import { customers } from "../../assets/js/firebase.js";
import { formatDate } from "../../assets/js/common";
export default {
  components: {
    DateRange
  },
  data() {
    return {
      responses: status,
      list: [],
      form: {
        updated_at: [],
        status: -1,
        template: "all",
        sms: "all"
      }
    };
  },
  computed: {
    templates() {
      let list = [];
      let templates = this.$store.getters.templates;
      templates.forEach(item => {
        if (item.type === 0) list.push(item);
      });
      list = list.sort((a, b) => {
        return a.name.localeCompare(b.name);
      });
      list.unshift({
        name: "All",
        id: "all"
      });
      return list;
    },
    sms() {
      let list = [];
      list.push({
        name: "All",
        value: "all"
      });
      Object.keys(smsList).forEach(key => {
        list.push({
          name: smsList[key],
          value: key
        });
      });
      return list;
    },
    date() {
      const vm = this;
      let { updated_at } = vm.form;
      let start = moment()
        .subtract(30, "days")
        .format("YYYY-MM-DDTHH:mm:ss");
      let end = vm.end(new Date());
      if (updated_at.length === 1) {
        start = vm.start(updated_at[0]);
        end = vm.end(updated_at[0]);
      }
      if (updated_at.length === 2) {
        let date1 = moment(updated_at[0]);
        let date2 = moment(updated_at[1]);
        if (date1.isBefore(date2)) {
          start = vm.start(date1);
          end = vm.end(date2);
        } else {
          start = vm.start(date2);
          end = vm.end(date1);
        }
      }
      return { start, end };
    }
  },
  methods: {
    start(date) {
      return moment(date)
        .startOf("day")
        .format("YYYY-MM-DDTHH:mm:ss");
    },
    end(date) {
      return moment(date)
        .endOf("day")
        .format("YYYY-MM-DDTHH:mm:ss");
    },
    reset() {
      const vm = this;
      let start = moment()
        .subtract(30, "days")
        .format("YYYY-MM-DD");
      let end = moment().format("YYYY-MM-DD");
      vm.form = {
        updated_at: [start, end],
        status: -1,
        template: "all",
        sms: "all"
      };
      vm.$store.commit("SET_CUSTOMERS_QUERY", {});
      vm.init();
    },
    async fetch() {
      const vm = this;
      let { status, template, sms } = vm.form;
      let doc = {};
      Object.keys(vm.form).forEach(key => {
        doc[key] = vm.form[key];
      });
      vm.$store.commit("SET_CUSTOMERS_QUERY", doc);
      let { start, end } = vm.date;
      let query = customers
        .orderBy("updated_at", "desc")
        .where("updated_at", ">=", start)
        .where("updated_at", "<=", end);
      if (status !== -1) {
        query = query.where("status", "==", status);
      } else {
        query = query.where("status", "in", [0, 4]);
      }
      if (template !== "all") query = query.where("template", "==", template);
      if (sms !== "all") query = query.where("sms", "==", sms);
      console.log(sms);
      vm.$store.commit("SET_CUSTOMERS", []);
      try {
        let list = [];
        vm.$root.loader = true;
        let snap = await query.get();
        snap.docs.forEach(item => {
          let doc = item.data();
          doc.id = item.id;
          doc.created_at = formatDate(doc.created_at);
          doc.updated_at = formatDate(doc.updated_at);
          vm.responses.forEach(item => {
            if (item.value === doc.status) {
              doc.status = item.name;
            }
          });
          list.push(doc);
        });
        vm.$store.commit("SET_CUSTOMERS", list);
        vm.$root.loader = false;
      } catch (e) {
        vm.$root.loader = false;
        vm.$root.alert(e.message);
      }
    },
    init() {
      const vm = this;
      let doc = vm.$store.getters.customersQuery;
      if (doc.updated_at === undefined) {
        vm.fetch();
      }
      Object.keys(vm.form).forEach(key => {
        if (doc[key] !== undefined) {
          vm.form[key] = doc[key];
        }
      });
      vm.fetch();
    }
  },
  beforeMount() {
    this.init();
  }
};
</script>

<style></style>
